var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"part-tinymce"},[_c('tinymce-vue',{attrs:{"init":_vm.init,"disabled":_vm.disabled},on:{"onClick":_vm.onClick},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }